import hydrate from '../common/hydrate';
import SideNav from './components/SideNav';
import { root, name } from './manifest.json';
hydrate(SideNav, root, name);
if (module.hot) {
    module.hot.accept();
}
